module.exports = __webpack_public_path__ + "static/media/phone.bacc2d0a.svg";